import * as PIXI from 'pixi.js';
import TextElement from "./TextElement";
import { CONSTANTS } from '../../PreviewDisplayConstants';
import { collectionHelper } from '../../../../../../utilities/basicUtilities';

export default class LyricsContainer {
    constructor(stage, zIndex) {
        this.stage = stage;
        this.container = new PIXI.Container();
        this.container.zIndex = zIndex;
        this.lyricsSegments = [];

        // The line held by a canvas drag, or null. While it is set, the line is kept on screen whatever
        // the playback time; see draw.
        this.draggedLine = null;

        // The element to render the lyrics
        this.textElement = new TextElement(this.container);
        this.stage.addChild(this.container);

        // Set the default position for lyrics
        this.container.position.set(CONSTANTS.DEFAULT_MID_X, CONSTANTS.DEFAULT_MID_Y);
    }

    update(config) {
        // Convert the lyrics properties to the text properties
        const textConfiguration = this.convertToTextConfiguration(config);

        // The settings carry no words; the line arrives through draw. A settings update while a line is
        // held would otherwise blank it, and draw is not allowed to bring it back until it is let go.
        if (this.draggedLine !== null)
            textConfiguration.text = this.draggedLine;

        this.lyricsSegments = config.segments;
        this.textElement.update(textConfiguration, 0);
    }

    updateStage(stage) {
        this.stage = stage;
        this.stage.addChild(this.container);
    }

    // A canvas drag takes hold of whichever line is showing and keeps it there until the pointer lets
    // go. The playback carries on underneath, and left to itself draw would swap the words for the next
    // line's, or take them away between lines, from right under the pointer.
    startDrag() {
        this.draggedLine = this.textElement.text.text;
    }

    stopDrag() {
        this.draggedLine = null;
    }

    moveTo(position) {
        this.textElement.moveTo(position);
    }

    draw(playbackTime) {
        if (this.draggedLine !== null)
            return;

        if (this.lyricsSegments && this.lyricsSegments.length > 0) {
            // Select the segments that are in current playback range
            const selectedSegments = collectionHelper(this.lyricsSegments)
                .getWhere((ls) => playbackTime >= ls.startTime && playbackTime <= ls.endTime);

            if (selectedSegments && selectedSegments.length > 0) {
                this.textElement.setVisibility(true);
                this.textElement.changeTextValue(selectedSegments[0].text);
            } else {
                this.textElement.setVisibility(false);
                this.textElement.changeTextValue('');
            }
        }
    }

    convertToTextConfiguration(lyricsConfiguration) {
        const convertedObject = {
            text: '',
            color: lyricsConfiguration.style.color,
            font: lyricsConfiguration.style.font,
            fontSize: lyricsConfiguration.style.fontSize,
            bold: lyricsConfiguration.style.bold,
            ...lyricsConfiguration.style,
            glowSettings: lyricsConfiguration.style.glowSettings,
            shadowSettings: lyricsConfiguration.style.shadowSettings,
            drift: lyricsConfiguration.drift,
            position: {
                x: lyricsConfiguration.style.position.x,
                y: lyricsConfiguration.style.position.y
            },
            anchorPoint: lyricsConfiguration.style.anchorPoint
        };

        return convertedObject;
    }

    destroy() {
        this.container.destroy({ children: true });
    }
}